import * as req from 'api/actions';
import * as c from './constants';

export const validate = (payload, callback, errorCallback) => req.item(
  c.VALIDATE,
  'api/v1/administrators/qr_code/validate',
  callback,
  payload,
  false,
  errorCallback
);

export default {}